import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layouts from "../../Components/Layouts/Layouts.js";
import "../../styles/Hostseminar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "../../axiosinstens";
import swal from "sweetalert";
import CryptoJS from "crypto-js";
const EventForm = () => {
  const [eventDuration, setEventDuration] = useState("less");
  const [formData, setFormData] = useState({
    name: "",
    booking_url: "",
    address: "",
    start_date: "",
    start_time: "",
    end_date: "",
    organiser: "",
    spaces: "",
    image: null,
    adsimage: null,
    promotionalImages: null,
    categorie_id: "",
    subcategorie_id: "",
    subsubcategorie_id: "",
    about_seminar: "",
    about_presenter: "",
    plan_id: "",
    event_type: "",
    offer_code: "",
    event_price: null,
    timings_morethen: "",
    eventDuration: eventDuration,
  });
  const [inputCategorie, setCategorie] = useState();
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [plan_data, setPlanData] = useState([]);
  const [settings_data, setSettingsData] = useState([]);
  const [selectedPlanName, setSelectedPlanName] = useState("");
  const [offerMessage, setOfferMessage] = useState("");
  const [offerData, setOfferData] = useState(null);
  const [promotionalImages, setPromotionalImages] = useState([]);
  const [promoErrors, setPromoErrors] = useState("");

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  //preview image
  const [eventImage, setEventImage] = useState(null);
  const [adsImage, setAdsImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authToken, setAuthToken] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const init = async () => {
      let decryptedToken = "";
      let decryptedOrganizer = null;

      // 1️⃣ Decrypt token
      const encryptedToken = localStorage.getItem("tokenJwt");
      if (encryptedToken) {
        try {
          const bytes = CryptoJS.AES.decrypt(
            encryptedToken,
            "secret-key-token-seminar"
          );
          decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
          setAuthToken(decryptedToken);
        } catch (err) {
          console.error("Token decrypt error");
        }
      }

      // 2️⃣ Decrypt organizer
      const encryptedOrganizer = localStorage.getItem("organizer");
      if (encryptedOrganizer) {
        try {
          const bytes = CryptoJS.AES.decrypt(
            encryptedOrganizer,
            "secret-organizer-key-seminar"
          );
          decryptedOrganizer = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch (err) {
          console.error("Organizer decrypt error");
        }
      }

      // 3️⃣ If missing, redirect to login
      if (!decryptedToken || !decryptedOrganizer) {
        localStorage.removeItem("organizer");
        localStorage.removeItem("tokenJwt");
        setIsLoggedIn(false);
        navigate("/login");
        return;
      }

      // 4️⃣ Load organizer data
      try {
        const categorie = await axios.get("/getCategorie", {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        });

        const plan = await axios.get("/getPlan", {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        });

        setPlanData(plan.data.plan);
        setSettingsData(plan.data.settings);

        setFormData((prev) => ({
          ...prev,
          organiser: decryptedOrganizer._id,
        }));

        setCategorie(categorie.data.categories);
      } catch (err) {
        localStorage.removeItem("organizer");
        localStorage.removeItem("tokenJwt");
        setIsLoggedIn(false);
        navigate("/login");
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (formData.categorie_id && authToken) {
      axios
        .get(`/getSubCategorie/${formData.categorie_id}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => setSubCategories(response.data.subcategories))
        .catch((error) => {console.error("Error loading subcategories:", error);});
    } else {
      setSubCategories([]);
      setFormData({
        ...formData,
        subcategorie_id: null,
        subsubcategorie_id: null,
      });
    }
  }, [formData.categorie_id, authToken]);

  useEffect(() => {
    if (formData.subcategorie_id && authToken) {
      axios
        .get(`/getSubSubCategorie/${formData.subcategorie_id}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => setSubSubCategories(response.data.subsubcategories))
        .catch((error) =>
          console.error("Error loading sub-subcategories:", error)
        );
    } else {
      setSubSubCategories([]);
      setFormData({ ...formData, subsubcategorie_id: null });
    }
  }, [formData.subcategorie_id, authToken]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.event_type) newErrors.event_type = "Select Event Type.";
    if (!formData.name.trim()) newErrors.name = "Event Name is required.";
    if (!formData.booking_url.trim())
      newErrors.booking_url = "Booking URL is required.";
    else if (!/^https?:\/\/.+$/.test(formData.booking_url))
      newErrors.booking_url = "Enter a valid URL.";
    if (!formData.address.trim() && formData.event_type !== "online_event")
      newErrors.address = "Event Address is required.";

    if (!formData.categorie_id)
      newErrors.categorie_id = "Please select an categirie.";

    if (!formData.plan_id) newErrors.plan_id = "Please select an plan.";

    if (subCategories.length && !formData.subcategorie_id)
      newErrors.subcategorie_id = "Please select an sub categirie.";

    if (subSubCategories.length && !formData.subsubcategorie_id)
      newErrors.subsubcategorie_id = "Please select an sub sub categirie.";

    if (selectedPlanName !== "At Will") {
      if (!formData.spaces)
        newErrors.spaces = "Maximum attendees are required.";
      else if (formData.spaces < 1)
        newErrors.spaces = "Seats must be at least 1.";
    }

    if (!formData.image) newErrors.image = "Please upload an event image.";

    if (!formData.adsimage && selectedPlanName === "Featured Event")
      newErrors.adsimage = "Please upload an ads image.";

    if (!formData.event_price)
      newErrors.event_price = "Please enter Registration fee.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    let updatedFields = {};
    // Handle textarea word limit
    if (name === "about_seminar" || name === "about_presenter") {
      const wordCount = value.trim().split(/\s+/).length;
      if (wordCount > 200) {
        alert("Maximum 200 words allowed.");
        return;
      }
      updatedFields[name] = value;
    }

    // Plan selection
    else if (name === "plan_id") {
      const selectedPlan = plan_data.find((plan) => plan._id === value);
      setSelectedPlanName(selectedPlan?.name || "");
      updatedFields[name] = value;
    }

    // Images
    else if (name === "event-image") {
      setEventImage(files[0]);
      updatedFields.image = files[0];
    } else if (name === "ads-image") {
      setAdsImage(files[0]);
      updatedFields.adsimage = files[0];
    } else if (name === "promo-images") {
      const newFiles = Array.from(files);
      const totalFiles = promotionalImages.length + newFiles.length;

      if (totalFiles > 3) {
        setPromoErrors("You can select a maximum of 3 promotional images.");
        return;
      }

      setPromotionalImages([...promotionalImages, ...newFiles]);
      updatedFields.promotionalImages = [...promotionalImages, ...newFiles];
      setPromoErrors("");
    }

    // Offer code
    else if (name === "offer_code") {
      await checkOfferCode(value);
      updatedFields[name] = value;
    }
    // Regular fields
    else {
      updatedFields[name] = files ? files[0] : value;
    }

    let newFormData = {
      ...formData,
      ...updatedFields,
    };
    newFormData.eventDuration = eventDuration;
    // Restrict end_date within 7 days of start_date
    // In handleChange()
    if (name === "end_date" && newFormData.start_date) {
      const start = new Date(newFormData.start_date);
      const end = new Date(value);
      const diffDays = (end - start) / (1000 * 60 * 60 * 24);

      if (eventDuration === "less" && diffDays > 10) {
        swal(
          "Error",
          "End date must be within 10 days of the start date.",
          "error"
        );
        return;
      }

      const days = getDateRange(newFormData.start_date, value);
      const updatedTimes = {};
      days.forEach((d) => {
        updatedTimes[d] = formData.times?.[d] || {};
      });

      newFormData.end_date = value;
      newFormData.times = updatedTimes;
    }

    if (name === "start_date" && newFormData.end_date) {
      const start = new Date(value);
      const end = new Date(newFormData.end_date);
      const diffDays = (end - start) / (1000 * 60 * 60 * 24);

      if (eventDuration === "less" && (diffDays > 10 || diffDays < 0)) {
        swal(
          "Error",
          "End date must be within 10 days of the start date.",
          "error"
        );
        newFormData.end_date = "";
        newFormData.times = {};
      } else {
        const days = getDateRange(value, newFormData.end_date);
        const updatedTimes = {};
        days.forEach((d) => {
          updatedTimes[d] = formData.times?.[d] || {};
        });
        newFormData.times = updatedTimes;
      }

      newFormData.start_date = value;
    }

    // Handle time fields
    if (name.startsWith("start_time_") || name.startsWith("end_time_")) {
      const match = name.match(/(start_time|end_time)_(.+)/);
      if (!match) return;

      const key = match[1]; // "start_time" or "end_time"
      const dateKey = match[2];
      const timeField = key === "start_time" ? "start" : "end";

      const updatedTimes = {
        ...(formData.times || {}),
        [dateKey]: {
          ...(formData.times?.[dateKey] || {}),
          [timeField]: value,
        },
      };
      const newFormData = {
        ...formData,
        times: updatedTimes,
      };
      
      setFormData(newFormData);
      return; // Early return so we don't call `setFormData` again later
    }
    
    setFormData(newFormData);
  };

  const handleRemovePromotionalImage = (index) => {
    const updatedImages = promotionalImages.filter((_, i) => i !== index);
    setPromotionalImages(updatedImages);
    
    setFormData({
      ...formData,
      promotionalImages: updatedImages,
    });
  };

  const handleRemoveImage = () => {
    setEventImage(null);
    setFormData({ ...formData, ["event-image"]: null });
    document.getElementById("file-upload").value = null; // reset input
  };

  const handleRemoveAdsImage = () => {
    setAdsImage(null);
    setFormData({ ...formData, ["ads-image"]: null });
    document.getElementById("ads-file-upload").value = null; // reset input
  };

  const checkOfferCode = async (value) => {
    try {
      const response = await axios.post(
        "checkOfferCode",
        { offer_code: value }, // body
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.exists) {
        setOfferMessage("✅ Offer code is valid");
        setOfferData(response?.data?.offer_details);
      } else {
        setOfferMessage("❌ Offer code does not exist");
        setOfferData(null);
      }
    } catch (error) {
      setOfferMessage("⚠️ Error checking offer code");
      setOfferData(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    setLoading(true); // Start loading

    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "times") {
        formDataToSend.append(key, JSON.stringify(value));
      } else if (key === "promotionalImages") {
        value.forEach((file) => {
          formDataToSend.append("promotionalImages", file);
        });
      } else {
        formDataToSend.append(key, value);
      }
    });

    try {
      const response = await axios.post("seminarRegister", formDataToSend, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.seminar.amount === 0) {
        const dataToSend = {
          selectedPlayersData: [
            {
              name: response.data.organizer.name,
              email: response.data.organizer.email,
              price: response.data.seminar.amount,
            },
          ],
          totalPrice: response.data.seminar.amount,
          eventID: response.data.seminar._id,
          trn_id: "",
          paymentIntent: "",
        };
        await axios.post("updatemyseminar", dataToSend, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });

        const userSendEmail = {
          name: response.data.organizer.name,
          email: response.data.organizer.email,
          details: response.data.seminar,
        };

        await axios.post("userSendEmail", userSendEmail, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });
        await axios.post("adminSendEmail", userSendEmail, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });

        swal("Success", "Seminar hosted successfully!", "success").then(() => {
          window.location.reload();
        });
      } else {
        navigate(`/Payment`, {
          state: {
            seminar_data: response.data.seminar,
            settings: response.data.settings,
            organizer: response.data.organizer,
          },
        });
      }
    } catch (error) {
      swal("Error", "Error hosting seminar.", "error");
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleCancel = () => {
    // Reset form fields
    setFormData({
      event_type: "",
      name: "",
      categorie_id: "",
      subcategorie_id: "",
      subsubcategorie_id: "",
      address: "",
      booking_url: "",
      start_date: "",
      start_time: "",
      end_date: "",
      spaces: "",
      plan_id: "",
      about_seminar: "",
      about_presenter: "",
      event_price: "",
      offer_code: "",
    });

    // Clear images and errors
    setEventImage(null);
    setAdsImage(null);
    setErrors({});
    setOfferMessage("");
    setSelectedPlanName("");
    setSubCategories([]);
    setSubSubCategories([]);
  };

  const getDateRange = (start, end) => {
    const dateList = [];
    let current = new Date(start);

    while (current <= new Date(end)) {
      dateList.push(current.toISOString().split("T")[0]);
      current.setDate(current.getDate() + 1);
    }

    return dateList;
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  return (
    <Layouts>
      <div className="hostseminar">
        <div className="seminar-container">
          <div className="evn">
            <h2>
              <span></span> Host A Seminar
            </h2>
            <hr />
          </div>
          <div className="hostseminarall">
            <div className="hostseminarform">
              <div className="row">
                <div className="col-md-6">
                  <label>Event Type</label>
                  <div className="select-wrapper">
                    <select
                      className="custom-select"
                      name="event_type"
                      value={formData.event_type}
                      onChange={handleChange}
                    >
                      <option value="">Select type</option>
                      <option value="in_person">In person</option>
                      <option value="online_event">Online Event</option>
                    </select>
                  </div>
                  {errors.event_type && (
                    <p className="error-text">{errors.event_type}</p>
                  )}
                </div>
                <div className="col-md-6">
                  <label>Select Plan</label>
                  <div className="select-wrapper">
                    <select
                      className="custom-select"
                      name="plan_id"
                      value={formData.plan_id}
                      onChange={handleChange}
                    >
                      <option value="">Select Plan</option>
                      {plan_data?.map((plans) => (
                        <option key={plans._id} value={plans._id}>
                          {plans.name} - {settings_data.currency_symbol}
                          {plans.amount}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.plan_id && (
                    <p className="error-text">{errors.plan_id}</p>
                  )}
                </div>
                <div className="col-md-6">
                  <label>Event Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Event Name"
                    onChange={handleChange}
                    required
                  />
                  {errors.name && <p className="error-text">{errors.name}</p>}
                </div>

                <div className="col-md-6">
                  <label>Select Category</label>
                  <div className="select-wrapper">
                    <select
                      className="custom-select"
                      name="categorie_id"
                      value={formData.categorie_id}
                      onChange={handleChange}
                    >
                      <option value="">Select category</option>
                      {inputCategorie?.map((categorie) => (
                        <option key={categorie._id} value={categorie._id}>
                          {categorie.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.categorie_id && (
                    <p className="error-text">{errors.categorie_id}</p>
                  )}
                </div>
                {subCategories.length > 0 && (
                  <div className="col-md-6">
                    <label>Select Sub Category</label>
                    <select
                      className="custom-select"
                      name="subcategorie_id"
                      value={formData.subcategorie_id || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Sub Category</option>
                      {subCategories.map((subcat) => (
                        <option key={subcat._id} value={subcat._id}>
                          {subcat.name}
                        </option>
                      ))}
                    </select>
                    {errors.subcategorie_id && (
                      <p className="error-text">{errors.subcategorie_id}</p>
                    )}
                  </div>
                )}

                {subSubCategories.length > 0 && (
                  <div className="col-md-6">
                    <label>Select Sub Sub Category</label>
                    <select
                      className="custom-select"
                      name="subsubcategorie_id"
                      value={formData.subsubcategorie_id || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Sub Sub Category</option>
                      {subSubCategories.map((subsub) => (
                        <option key={subsub._id} value={subsub._id}>
                          {subsub.name}
                        </option>
                      ))}
                    </select>
                    {errors.subsubcategorie_id && (
                      <p className="error-text">{errors.subsubcategorie_id}</p>
                    )}
                  </div>
                )}
                {formData.event_type === "in_person" && (
                  <div className="col-md-6">
                    <label>Event Address</label>
                    <input
                      type="text"
                      name="address"
                      placeholder="Event Address"
                      onChange={handleChange}
                      required
                    />
                    {errors.address && (
                      <p className="error-text">{errors.address}</p>
                    )}
                  </div>
                )}
                <div className="col-md-6">
                  <label>
                    {selectedPlanName === "At Will"
                      ? "Video Payment Landing Page"
                      : "Event Booking URL"}
                  </label>
                  <input
                    type="url"
                    name="booking_url"
                    placeholder={
                      selectedPlanName === "At Will"
                        ? "Video Payment Landing Page"
                        : "Event Booking URL"
                    }
                    onChange={handleChange}
                    required
                  />
                  {errors.booking_url && (
                    <p className="error-text">{errors.booking_url}</p>
                  )}
                </div>

                {selectedPlanName !== "At Will" && (
                  <>
                    <div className="col-md-12">
                      <label>Event Duration</label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "5px",
                        }}
                      >
                        <div style={{ display: "contents", width: "50%" }}>
                          <input
                            type="radio"
                            id="lessThan10"
                            name="eventDuration"
                            value="less"
                            checked={eventDuration === "less"}
                            onChange={(e) => setEventDuration(e.target.value)}
                          />
                          <label
                            htmlFor="lessThan10"
                            style={{ marginLeft: "5px" }}
                          >
                            Less than 10 days event
                          </label>
                        </div>
                        <div style={{ display: "contents", width: "50%" }}>
                          <input
                            type="radio"
                            id="moreThan10"
                            name="eventDuration"
                            value="more"
                            checked={eventDuration === "more"}
                            onChange={(e) => setEventDuration(e.target.value)}
                          />
                          <label
                            htmlFor="moreThan10"
                            style={{ marginLeft: "5px" }}
                          >
                            More than 10 days event
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label>Start Date</label>
                      <input
                        type="date"
                        name="start_date"
                        onChange={handleChange}
                        min={getTomorrowDate()}
                        required
                      />
                      {errors.start_date && (
                        <p className="error-text">{errors.start_date}</p>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label>End Date</label>
                      <input
                        type="date"
                        name="end_date"
                        onChange={handleChange}
                        required
                        min={formData.start_date || ""}
                      />

                      {errors.end_date && (
                        <p className="error-text">{errors.end_date}</p>
                      )}
                    </div>
                  </>
                )}

                {eventDuration === "more" && (
                  <div className="col-md-12">
                    <label>
                      Timings (
                      <small className="error-text">
                        {formData.timings_morethen?.trim().split(/\s+/)
                          .length || 0}
                        /200 words
                      </small>
                      )
                    </label>
                    <textarea
                      name="timings_morethen"
                      placeholder="Please Enter Your Schedule Here"
                      onChange={handleChange}
                      value={formData.timings_morethen || ""}
                      required
                      className="form-control"
                    ></textarea>
                  </div>
                )}

                {formData.start_date &&
                  formData.end_date &&
                  eventDuration === "less" &&
                  getDateRange(formData.start_date, formData.end_date).map(
                    (date) => (
                      <React.Fragment key={date}>
                        <div className="col-md-6">
                          <label>Start Time for {date}</label>
                          <input
                            type="time"
                            name={`start_time_${date}`}
                            value={formData.times?.[date]?.start || ""}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <label>End Time for {date}</label>
                          <input
                            type="time"
                            name={`end_time_${date}`}
                            value={formData.times?.[date]?.end || ""}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </React.Fragment>
                    )
                  )}

                {selectedPlanName != "At Will" && (
                  <div className="col-md-6">
                    <label>Maximum attendees</label>
                    <input
                      type="number"
                      name="spaces"
                      placeholder="Maximum attendees"
                      onChange={handleChange}
                      required
                    />
                    {errors.spaces && (
                      <p className="error-text">{errors.spaces}</p>
                    )}
                  </div>
                )}

                <div className="col-md-6">
                  <label>Event Image (600x600)</label>
                  <div className="file-upload-wrapper">
                    <label htmlFor="file-upload" className="custom-file-upload">
                      📁 Upload File
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      name="event-image"
                      onChange={handleChange}
                      accept="image/*"
                    />
                  </div>
                  {eventImage && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={URL.createObjectURL(eventImage)}
                        alt="Preview"
                        style={{
                          width: "100%",
                          maxHeight: "250px",
                          objectFit: "contain",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mt-2"
                        onClick={handleRemoveImage}
                      >
                        ❌ Remove Image
                      </button>
                    </div>
                  )}
                  {errors.image && <p className="error-text">{errors.image}</p>}
                </div>

                <div className="col-md-6">
                  <label>Promotional Images (Max 3)</label>
                  <div className="file-upload-wrapper">
                    <label
                      htmlFor="promo-upload"
                      className="custom-file-upload"
                    >
                      📁 Upload Files
                    </label>
                    <input
                      id="promo-upload"
                      type="file"
                      name="promo-images"
                      multiple
                      accept="image/*"
                      onChange={handleChange}
                    />
                  </div>
                  {promotionalImages.length > 0 && (
                    <div className="col-md-6" style={{ marginTop: "10px" }}>
                      {promotionalImages.map((image, index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <img
                            src={URL.createObjectURL(image)}
                            alt={`Promotional ${index + 1}`}
                            style={{
                              width: "100%",
                              maxHeight: "200px",
                              objectFit: "contain",
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => handleRemovePromotionalImage(index)}
                          >
                            ❌ Remove Image
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  {promoErrors && <p className="error-text">{promoErrors}</p>}
                </div>

                {selectedPlanName === "Featured Event" && (
                  <div className="col-md-6">
                    <label>Ads Image (600x600)</label>
                    <div className="file-upload-wrapper">
                      <label
                        htmlFor="ads-image-upload"
                        className="custom-file-upload"
                      >
                        📁 Upload File
                      </label>
                      <input
                        id="ads-image-upload"
                        type="file"
                        name="ads-image"
                        onChange={handleChange}
                        accept="image/*"
                      />
                    </div>
                    {adsImage && (
                      <div style={{ marginTop: "10px" }}>
                        <img
                          src={URL.createObjectURL(adsImage)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            maxHeight: "250px",
                            objectFit: "contain",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm mt-2"
                          onClick={handleRemoveAdsImage}
                        >
                          ❌ Remove Image
                        </button>
                      </div>
                    )}
                    {errors.adsimage && (
                      <p className="error-text">{errors.adsimage}</p>
                    )}
                  </div>
                )}
                <div className="col-md-12">
                  <label>
                    About Seminar (
                    <small className="error-text">
                      {formData.about_seminar?.trim().split(/\s+/).length || 0}
                      /200 words
                    </small>
                    )
                  </label>
                  <textarea
                    name="about_seminar"
                    placeholder="Write about the seminar..."
                    onChange={handleChange}
                    value={formData.about_seminar || ""}
                    required
                    className="form-control"
                  ></textarea>
                </div>

                <div className="col-md-12">
                  <label>
                    About Presenter (
                    <small className="error-text">
                      {formData.about_presenter?.trim().split(/\s+/).length ||
                        0}
                      /200 words
                    </small>
                    )
                  </label>
                  <textarea
                    name="about_presenter"
                    placeholder="Write about the presenter..."
                    onChange={handleChange}
                    value={formData.about_presenter || ""}
                    required
                    className="form-control"
                  ></textarea>
                </div>
                <div className="col-md-6">
                  <label>Registration fee</label>
                  <input
                    type="number"
                    name="event_price"
                    placeholder="Enter Registration fee"
                    onChange={handleChange}
                  />
                  {errors.event_price && (
                    <p className="error-text">{errors.event_price}</p>
                  )}
                </div>
                <div className="col-md-6">
                  <label>Offer Code</label>
                  <input
                    type="text"
                    name="offer_code"
                    placeholder="Enter Offer Code"
                    onChange={handleChange}
                  />
                  {offerMessage && (
                    <small
                      style={{
                        color: offerMessage.includes("valid") ? "green" : "red",
                      }}
                    >
                      {offerMessage}{" "}
                      {offerData
                        ? offerData.type === "percentage"
                          ? `( ${offerData.offer_value || 0}% )`
                          : `( ${offerData.offer_value || 0} )`
                        : null}
                    </small>
                  )}
                </div>

                <div className="col-md-12 mx-auto d-flex justify-content-between mt-4">
                  <button className="cancelButton" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button
                    className="submitButton"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Host A Seminar"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default EventForm;
